import { createBrowserHistory } from 'history'
import { createStore, applyMiddleware, compose } from 'redux'
import { routerMiddleware } from 'connected-react-router'

import createRootReducer from './rootReducer'

export const history = createBrowserHistory()

const composeEnhancers = (<any>window).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
const middleware = [routerMiddleware(history)]

const store = createStore(createRootReducer(history), composeEnhancers(applyMiddleware(...middleware)))

export default store
